const defaultWidgetConfig = {
    dimensions: {
        brand: String(import.meta.env.VITE_APP_BRAND) ?? '',
        country: String(import.meta.env.VITE_APP_COUNTRY) ?? '',
        region: String(import.meta.env.VITE_APP_REGION) ?? '',
        language: String(import.meta.env.VITE_APP_LANGUAGE) ?? '',
    },
};
export default defaultWidgetConfig;
//# sourceMappingURL=defaultWidgetConfig.js.map